import React, { useState, useEffect } from 'react';
import { getToken, setToken } from './api';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Plans from './pages/Plans';
import Transactions from './pages/Transactions';
import Banners from './pages/Banners';
import Campaigns from './pages/Campaigns';
import Companions from './pages/Companions';
import Support from './pages/Support';
import Deletions from './pages/Deletions';

const NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: '📊' },
  { key: 'users', label: 'Users', icon: '👥' },
  { key: 'plans', label: 'Membership', icon: '👑' },
  { key: 'transactions', label: 'Revenue', icon: '💳' },
  { key: 'campaigns', label: 'Campaigns', icon: '📣' },
  { key: 'companions', label: 'Friend on Rent', icon: '👯' },
  { key: 'support', label: 'Support', icon: '🆘' },
  { key: 'deletions', label: 'Deletions', icon: '🗑️' },
  { key: 'banners', label: 'Content', icon: '🖼️' },
];

export default function App() {
  const [authed, setAuthed] = useState(!!getToken());
  const [view, setView] = useState('dashboard');

  useEffect(() => { document.title = 'SparkSync Admin'; }, []);

  if (!authed) return <Login onLogin={() => setAuthed(true)} />;

  const logout = () => { setToken(null); setAuthed(false); };

  return (
    <div style={styles.shell}>
      <aside style={styles.sidebar}>
        <div style={styles.brand}>
          <span style={styles.brandHeart}>💞</span>
          <span style={styles.brandText}>SparkSync</span>
        </div>
        <nav style={{ flex: 1 }}>
          {NAV.map((n) => (
            <button
              key={n.key}
              onClick={() => setView(n.key)}
              style={{ ...styles.navItem, ...(view === n.key ? styles.navItemActive : {}) }}
            >
              <span style={{ fontSize: 18 }}>{n.icon}</span>
              <span>{n.label}</span>
            </button>
          ))}
        </nav>
        <button onClick={logout} style={{ ...styles.navItem, color: 'var(--primary)' }}>
          <span style={{ fontSize: 18 }}>⎋</span>
          <span>Log out</span>
        </button>
      </aside>

      <main style={styles.main} className="scrollbar">
        {view === 'dashboard' && <Dashboard />}
        {view === 'users' && <Users />}
        {view === 'plans' && <Plans />}
        {view === 'transactions' && <Transactions />}
        {view === 'campaigns' && <Campaigns />}
        {view === 'companions' && <Companions />}
        {view === 'support' && <Support />}
        {view === 'deletions' && <Deletions />}
        {view === 'banners' && <Banners />}
      </main>
    </div>
  );
}

const styles = {
  shell: { display: 'flex', height: '100vh' },
  sidebar: { width: 240, background: 'var(--bg-alt)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', padding: 16 },
  brand: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 12px 24px' },
  brandHeart: { fontSize: 24 },
  brandText: { fontSize: 20, fontWeight: 800 },
  navItem: { display: 'flex', alignItems: 'center', gap: 12, width: '100%', background: 'transparent', border: 'none', color: 'var(--text-dim)', padding: '13px 14px', borderRadius: 10, fontSize: 15, fontWeight: 600, textAlign: 'left', marginBottom: 4 },
  navItemActive: { background: 'rgba(255,77,109,0.14)', color: '#fff' },
  main: { flex: 1, overflowY: 'auto', padding: 32 },
};
